import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "pictorialbar",
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      console.log('this.dataChart', this.dataChart);
      var optionData = this.deepClone(this.dataChart);
      var symbol = this.validatenull(this.option.symbol) ? "" : "image://" + this.option.symbol;
      console.log('optionData', optionData);
      var color = this.option.color || "#fff";
      var fontSize = this.option.fontSize || 20;
      var maxData = 0;
      optionData.forEach(function (ele) {
        if (ele.value > maxData) maxData = ele.value;
      });
      var option = {
        tooltip: function () {
          return Object.assign(function () {
            if (_this.formatter) {
              return {
                formatter: function formatter(name) {
                  return _this.formatter(name, _this.dataChart);
                }
              };
            }

            return {};
          }(), {
            textStyle: {
              fontSize: _this.option.tipFontSize,
              color: _this.option.tipColor || "#fff"
            }
          });
        }(),
        xAxis: {
          show: this.vaildData(this.option.xAxisShow, true),
          max: maxData,
          splitLine: {
            show: false
          },
          offset: 10,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              color: this.option.nameColor || "#333",
              fontSize: this.option.xNameFontSize || 14
            }
          }
        },
        yAxis: {
          data: function () {
            return (Array.isArray(optionData) ? optionData : []).map(function (ele) {
              return ele.name;
            });
          }(),
          show: this.vaildData(this.option.yAxisShow, true),
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              color: this.option.nameColor || "#333",
              fontSize: this.option.yNameFontSize || 14
            }
          }
        },
        grid: {
          top: "center",
          height: Number(this.option.split) * 10,
          left: this.option.gridX || 70,
          right: this.option.gridX2 || 100
        },
        series: [{
          type: "pictorialBar",
          symbol: symbol,
          symbolRepeat: "fixed",
          symbolMargin: "5%",
          symbolClip: true,
          symbolSize: this.option.symbolSize || 30,
          symbolBoundingData: maxData,
          data: function () {
            return (Array.isArray(optionData) ? optionData : []).map(function (ele) {
              return ele.value;
            });
          }()
        }, {
          type: "pictorialBar",
          itemStyle: {
            normal: {
              opacity: 0.2
            }
          },
          label: {
            normal: {
              show: true,
              position: "right",
              offset: [10, 0],
              textStyle: {
                color: color,
                fontSize: fontSize
              }
            }
          },
          animationDuration: 0,
          symbol: symbol,
          symbolRepeat: "fixed",
          symbolMargin: "5%",
          symbolSize: 30,
          symbolBoundingData: maxData,
          data: function () {
            return (Array.isArray(optionData) ? optionData : []).map(function (ele) {
              return ele.value;
            });
          }()
        }]
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});